// extracted by mini-css-extract-plugin
export var attachButton = "_kr-8";
export var sendButton = "_kr-2";
export var sendDisabled = "_kr-4";
export var sendEnabled = "_kr-3";
export var sendIcon = "_kr-6";
export var sendIconDisabled = "_kr-7";
export var sendStreaming = "_kr-5";
export var textarea = "_kr-1";
export var wrapper = "_kr-0";